import { __decorate, __metadata } from "tslib";
import { Utils } from "../../Utils";
import { Observable } from '../../Model/Decorators';
import NeoModel from '../../Model/NeoModel';
var Notification = /** @class */ (function () {
    function Notification(options, body) {
        this.options = options;
        this.body = body;
        this.refreshValue = 1;
        this.identifier = Utils.uuidv4();
        this.key = "";
        options.state = this;
    }
    Notification.prototype.hide = function () {
        this.options.bindShow.value = false;
    };
    __decorate([
        Observable(),
        __metadata("design:type", Number)
    ], Notification.prototype, "refreshValue", void 0);
    Notification = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Object, Object])
    ], Notification);
    return Notification;
}());
export { Notification };
